module.exports = __webpack_public_path__ + "res/0-img_prize.f4b700e7c862965987beea42928e45ad.png";